<template>
    <div class="plugin">
        <div class="logo-container">
            <img :src="iconPath"/>
        </div>
        <div class="infos">
            <div class="name">{{ infos.name }}</div>
            <div class="desc">
                <span class="mode" :title="infos.mode"><font-awesome-icon v-if="modeIcon" :icon="modeIcon" :rotation="modeIconRotation" fixed-width></font-awesome-icon></span><span class="short-desc">{{ infos.shortDesc }}</span>
            </div>
        </div>
        <div class="state">


        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {
            iconPath(){
                return '/static/plugins/icons/'+this.infos.pluginId+'.svg'
            },
            modeIcon(){
                switch(this.infos.mode){
                    case 'Import':
                        return 'long-arrow-alt-down'
                    case 'Export':
                        return 'long-arrow-alt-up'
                    case 'Synchronization':
                        return 'exchange-alt'
                }
                return  null
            },
            modeIconRotation(){
                if(this.infos.mode == 'Synchronization'){
                    return 90
                }
                return null

            }
        },
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {},
        mounted: function () {

        },
        name: '',
        props: {
            infos: {
                type: Object,
                required: true
            },
            provider: {
                type: Object,
                default: null
            },
            category: {
                type: Object,
                default: null
            }
        },
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
    .plugin{
        background-color: #FFFFFF;
        border-radius: 6px;
        box-shadow: 0 1px 6px rgba(0,0,0,0.16);
        cursor: pointer;
        display: flex;
        padding: 20px;

        .logo-container{
            flex: 0 0 86px;
            padding-top: 10px;

            img{
                width: 66px;
            }
        }

        .infos{
            flex: 1 1 100%;
            overflow: hidden;

            .name{
                font-weight: 300;
                font-size: 40px;
                color: $main-black;
                text-transform: uppercase;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 46px;
                padding-top: 6px;
            }

            .desc{
                font-weight: 300;
                font-size: 16px;
                color: #6b6b6b;
                line-height: 24px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;


                .mode{

                }

                .short-desc{

                }
            }
        }

        .state{
            flex: 0 0 66px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/plugins/library/PluginItem.vue